export const validateEmail = (email) => {
  if (!email) return "";
  if (!email.includes("@") || !email.includes(".")) return "Enter a valid email address.";
  const parts = email.split("@");
  if (parts.length !== 2 || !parts[0] || !parts[1].includes(".")) return "Enter a valid email address.";
  return "";
};

export const passwordRules = [
  { label: "8–15 characters",         test: (v) => v.length >= 8 && v.length <= 15 },
  { label: "One uppercase letter",     test: (v) => /[A-Z]/.test(v) },
  { label: "One lowercase letter",     test: (v) => /[a-z]/.test(v) },
  { label: "One number",               test: (v) => /[0-9]/.test(v) },
  { label: "One special character",    test: (v) => /[#?!@$%^&*\-]/.test(v) },
];

export const validatePassword = (password) => {
  for (const rule of passwordRules) {
    if (!rule.test(password)) return `Password must include: ${rule.label.toLowerCase()}.`;
  }
  return "";
};
